import styles from "./AccountMenu.module.scss";
import { Link, NavLink } from "react-router-dom";
import { Icon } from "../SVGsprite/svgsprite";
import { useActor } from "@xstate/react";
import { AuthState } from "../../xstate/auth.machine";
import { useEffect, useCallback, useState } from "react";
import apiMethods from "../../api/apiMethods";

export function AccountMenu(props) {
	let [stateAuth, sendAuth] = useActor(AuthState);

	const [rules, setRules] = useState();

	const fetchRules = useCallback(async () => {
		try {
			const { data } = await apiMethods.docs.getDocs();
			const rules = data?.data?.find(item => item.type === "rules");
			setRules(rules || null);
		} catch (error) {
			console.log(error);
		}
	}, []);

	useEffect(() => {
		fetchRules();
	}, []);

	const [position, setPosition] = useState();

	useEffect(() => {
		if (stateAuth.context.type === "seller") {
			setPosition("Продавец");
		} else if (stateAuth.context.type === "owner") {
			setPosition("Партнер");
		} else {
			setPosition("Дистрибьютор");
		}
	}, [stateAuth.context.type]);

	useEffect(() => {
		if (stateAuth.context.type === "distributor") {
			const isDistributor = stateAuth.context.type === "distributor";
			const hasNewOrders = stateAuth.context.has_not_verified_service_orders;
			const alreadyShown = sessionStorage.getItem("isShowOrderPopup");
			if (isDistributor && hasNewOrders && !alreadyShown) {
				setShowNewOrderPopup(true);
			}
		}
	}, [stateAuth.context.type]);

	const [showNewOrderPopup, setShowNewOrderPopup] = useState(false);

	return (
		<section className={styles.accMenu}>
			{stateAuth.context.errorMsg && stateAuth.context.errorMsg.length > 0 && (
				<>
					{Array.isArray(stateAuth.context.errorMsg) ? (
						stateAuth.context.errorMsg?.map((item, index) => {
							return (
								<div className={"errorMessage"} key={index}>
									item
								</div>
							);
						})
					) : (
						<></>
					)}
				</>
			)}
			<div className={styles.profile}>
				<div className={styles.userInfo}>
					<div className={styles.userpic}>
						<img
							src={
								stateAuth.context?.avatar
									? stateAuth.context?.avatar
									: "/images/user-ph.png"
							}
							alt=""
						/>
					</div>
					<div className={styles.userName}>
						{stateAuth.context.name} {stateAuth.context.surname}
					</div>
					<div className="">{position}</div>
					<Link onClick={() => props.dialog?.hide()} to={"/account"}>
						Редактировать профиль
					</Link>

					{stateAuth.context.type === "seller" ||
					stateAuth.context.subtype === "dedicated_distributor" ? (
						<NavLink
							className={styles.balance}
							to={"transactions"}
							onClick={() => props.dialog?.hide()}
						>
							Счет:{" "}
							{new Intl.NumberFormat("ru-RU").format(stateAuth.context.balance)}{" "}
							баллов
						</NavLink>
					) : (
						""
					)}
				</div>

				<hr />
				<nav
					className={styles.navigation}
					aria-label={"Навигация по личному кабинету"}
				>
					{(stateAuth.context.type === "seller" ||
						stateAuth.context.subtype === "dedicated_distributor") &&
						stateAuth.context.user_identities_status === "verified" && (
							<div
								className={"btn btnSecondary btnIcon"}
								to={"points-form"}
								onClick={() => props.dialog?.hide()}
							>
								<img
									src="/images/success.svg"
									alt="check"
									style={{ width: "16px" }}
								/>
								Документы подтверждены
							</div>
						)}
					{(stateAuth.context.type === "seller" ||
						stateAuth.context.subtype === "dedicated_distributor") &&
						(stateAuth.context.user_identities_status ===
							"need_user_identity" ||
							stateAuth.context.user_identities_status === "new") && (
							<NavLink
								className={"btn btnSecondary btnIcon"}
								to={"points-form"}
								onClick={() => props.dialog?.hide()}
							>
								<Icon name={"icon-userStroke"} sizeW="16" sizeH="16" />
								{stateAuth.context.user_identities_status ===
								"need_user_identity"
									? "Подтвердить документы"
									: "Документы проверяются"}
							</NavLink>
						)}
					{stateAuth.context.type === "seller" && (
						<NavLink
							className={"btn btnSecondary btnIcon"}
							to={"receipts"}
							onClick={() => props.dialog?.hide()}
						>
							<Icon name={"icon-list"} sizeW="16" sizeH="16" />
							Мои чеки
						</NavLink>
					)}

					{stateAuth.context.type === "seller" &&
						stateAuth.context.service_order_verification_status ===
							"enabled" && (
							<NavLink
								className={"btn btnSecondary btnIcon"}
								to={"orders-list"}
								onClick={() => props.dialog?.hide()}
							>
								<Icon name={"icon-list-ok"} sizeW="15" sizeH="15" />
								Мои заказ-наряды
							</NavLink>
						)}

					{stateAuth.context.type === "distributor" &&
						stateAuth.context.subtype === "dedicated_distributor" && (
							<NavLink
								className={"btn btnSecondary btnIcon"}
								to={"reports"}
								onClick={() => props.dialog?.hide()}
							>
								<Icon name={"icon-list"} sizeW="16" sizeH="16" />
								Отчёты
							</NavLink>
						)}

					{stateAuth.context.type === "seller" && (
						<NavLink
							className={"btn btnSecondary btnIcon"}
							to={"sales"}
							onClick={() => props.dialog?.hide()}
						>
							<Icon name={"icon-chart"} sizeW="16" sizeH="16" />
							Мои продажи
						</NavLink>
					)}
					{stateAuth.context.type !== "seller" && (
						<NavLink
							className={"btn btnSecondary btnIcon"}
							to={"statistics"}
							onClick={() => props.dialog?.hide()}
						>
							<Icon name={"icon-statistics"} sizeW="16" sizeH="16" />
							Статистика
						</NavLink>
					)}

					{(stateAuth.context.type === "seller" ||
						stateAuth.context.subtype === "dedicated_distributor") && (
						<NavLink
							className={"btn btnSecondary btnIcon"}
							to={"transactions"}
							onClick={() => props.dialog?.hide()}
						>
							<Icon name={"icon-chart"} sizeW="16" sizeH="16" />
							Мои баллы
						</NavLink>
					)}

					{(stateAuth.context.type === "seller" ||
						stateAuth.context.subtype === "dedicated_distributor") && (
						<NavLink
							className={"btn btnSecondary btnIcon"}
							to={"gifts"}
							onClick={() => props.dialog?.hide()}
						>
							<Icon name={"icon-starStroke"} sizeW="16" sizeH="16" />
							Мои подарки
						</NavLink>
					)}

					{stateAuth.context.type === "owner" && (
						<NavLink
							className={"btn btnSecondary btnIcon"}
							to={"sale-point"}
							onClick={() => props.dialog?.hide()}
						>
							<Icon name={"icon-point"} sizeW="16" sizeH="16" />
							Торговые точки
						</NavLink>
					)}

					{stateAuth.context.type === "owner" && (
						<NavLink
							className={"btn btnSecondary btnIcon"}
							to={"sellers"}
							onClick={() => props.dialog?.hide()}
						>
							<Icon name={"icon-userStroke"} sizeW="16" sizeH="16" />
							Продавцы
						</NavLink>
					)}

					{stateAuth.context.type === "distributor" && (
						<NavLink
							className={"btn btnSecondary btnIcon"}
							to={"sale-points"}
							onClick={() => props.dialog?.hide()}
						>
							<Icon name={"icon-point"} sizeW="16" sizeH="16" />
							Торговые точки
						</NavLink>
					)}

					{stateAuth.context.type === "distributor" && (
						<NavLink
							className={"btn btnSecondary btnIcon"}
							to={"owners"}
							onClick={() => props.dialog?.hide()}
						>
							<Icon name={"icon-userStroke"} sizeW="16" sizeH="16" />
							Партнеры
						</NavLink>
					)}

					{stateAuth.context.type === "distributor" &&
						stateAuth.context.service_order_verification_status ===
							"enabled" && (
							<div style={{ position: "relative" }}>
								<NavLink
									className={"btn btnSecondary btnIcon order-point"}
									style={{ position: "relative" }}
									to={"order"}
									onClick={() => props.dialog?.hide()}
								>
									<Icon name={"icon-order"} sizeW="16" sizeH="16" />
									Заказ-наряды
									{stateAuth.context.has_not_verified_service_orders && (
										<div className="new_order_notification">
											<div>1</div>
											<img src={"/images/col.svg"} />
										</div>
									)}
								</NavLink>

								<div
									className="customSmallPopup"
									style={{
										display: showNewOrderPopup === true ? "block" : "none",
									}}
								>
									<svg
										onClick={() => {
											setShowNewOrderPopup(false);
											sessionStorage.setItem("isShowOrderPopup", "true");
										}}
										width="13"
										height="13"
										viewBox="0 0 13 13"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M11.166 0.900024L0.900269 11.1658"
											stroke="#AA3436"
											strokeWidth="1.8"
											strokeLinecap="round"
										/>
										<path
											d="M11.1738 11.1674L0.908082 0.901611"
											stroke="#AA3436"
											strokeWidth="1.8"
											strokeLinecap="round"
										/>
									</svg>
									У вас есть непроверенные
									<br /> заказ-наряды
								</div>
							</div>
						)}
				</nav>
			</div>

			<div className={styles.logout}>
				<a
					className={styles.vk}
					href="https://vk.com/zicrussia"
					target="__blank"
				>
					ZIC Russia | VK
				</a>
				<a
					className={styles.vk}
					href={Boolean(rules?.url) ? rules.url : "/docs/zic_rules.pdf"}
					target="__blank"
				>
					Правила программы
				</a>
				{stateAuth.context.type === "distributor" && (
					<a
						className={styles.vk}
						href={
							"https://storage.yandexcloud.net/zictop.public/documents/instructions_distributor.pdf"
						}
						target="__blank"
					>
						Инструкция
					</a>
				)}
				{stateAuth.context.type === "seller" && (
					<a
						className={styles.vk}
						href={
							"https://storage.yandexcloud.net/zictop.public/documents/instructions_seller.pdf"
						}
						target="__blank"
					>
						Инструкция
					</a>
				)}

				<button
					className={"btn btnSecondary btnIcon"}
					onClick={() => sendAuth({ type: "logout" })}
				>
					<Icon name={"icon-logout"} sizeW="16" sizeH="16" />
					Выйти из&nbsp;профиля
				</button>
			</div>
		</section>
	);
}
